(ns frontend.view.settings2.surveys.timeseries.event
  (:require [frontend.view.settings2.surveys.timeseries.model :as model]
            [re-frame.core :as rf]
            [ui.state.time.cofx :as time-cofx]))

(rf/reg-event-fx
 ::set-view-editor-tab
 [rf/trim-v]
 (fn [{db :db} [{:keys [ctx-path new-tab-str] :as ctx}]]
   (model/set-selected-tab db ctx)))

(rf/reg-event-db
 ::on-row-drag-end
 [rf/trim-v]
 (fn [db [{:keys [ctx-path] :as ctx}]]
   (model/on-row-drag-end db ctx)))

(rf/reg-event-db
 ::on-row-drag-move
 [rf/trim-v]
 (fn [db [{:keys [ctx-path params-js] :as ctx}]]
   (model/on-drag-move db ctx)))

(rf/reg-event-db
 ::set-selected-question-ids
 [rf/trim-v]
 (fn [db [{:keys [ctx-path ids] :as ctx}]]
   (model/set-selected-question-ids db ctx)))

(rf/reg-event-db
 ::remove-selected-questions
 [rf/trim-v]
 (fn [db [{:keys [ctx-path ids] :as ctx}]]
    (model/remove-selected-question-dis db ctx)))

(rf/reg-event-db
 ::set-preview-period-type
 [rf/trim-v]
 (fn [db [ctx]]
   (model/set-preview-period-type db ctx)))

(rf/reg-event-db
 ::set-preview-period-value
 [rf/trim-v]
 (fn [db [ctx]]
   (model/set-preview-period-value db ctx)))

(rf/reg-event-fx
 ::init-preview
 [rf/trim-v
  (rf/inject-cofx ::time-cofx/today-utc-midnight-ms)]
 (fn [{:keys [db today-utc-midnight-ms]} [ctx]]
   {:db (model/init-preview db (assoc ctx :today-utc-midnight-ms today-utc-midnight-ms))}))
